// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Details_checkbox__2wiud"};